import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DFPSlotsProvider, AdSlot, DFPManager } from "react-dfp";

import * as actions from "../actions/index";

import Home from "../components/Pages/Home/Home";
import Itineraries from "../components/Pages/Itineraries/Itineraries";
import Itineraries2 from "../components/Pages/Itineraries2/Itineraries2";
import ItinerariesPrintable from "../components/Pages/Itineraries2/ItinerariesPrintable"
import Events from "../components/Pages/Events/Events";
import Allevents from "../components/Pages/Allevents/Allevents";
import Ships from "../components/Pages/Ships/Ships";
import Agencies from "../components/Pages/Agencies/Agencies";
import Allagencies from "../components/Pages/Allagencies/Allagencies";
import Advertise from "../components/Pages/Advertise/Advertise";
import Terms from "../components/Pages/Terms/Terms";
import Contact from "../components/Pages/Contact/Contact";
import CustomPage from "../components/Pages/CustomPage/CustomPage";

import HomeEvents from "../components/Pages/Home/HomeEvents";

import ReactGA from "react-ga";

import { ANALYTICS_CODE, FETCH_URL } from "../utilities";
import {translate, getLanguage } from "../components/Translation/Translation";

ReactGA.initialize(ANALYTICS_CODE);

class Analytics extends React.Component {

  componentDidMount() {
    this.sendPageChange(this.props.location.pathname, this.props.location.search)
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname
      || this.props.location.search !== prevProps.location.search) {
      this.sendPageChange(this.props.location.pathname, this.props.location.search)
    }
  }

  sendPageChange(pathname, search) {
    const page = pathname + search
    ReactGA.set({page});
    ReactGA.pageview(page);
  }

  render() {
    return null
  }
}

class CookieConsent extends React.PureComponent { 
  state = {
    consent: false
  }

  handleClick = (event) => {
    event.preventDefault();
    this.setState({ consent: true })
  }

  render() {
    const { consent } = this.state;
    return(
      <div style={{
        display: !consent ? 'block' : 'none',
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100vw",
        zIndex: 999,
        textAlign: 'center',
        background: "rgba(255,255,255,0.5)",
        padding: "16px 0",
      }}>
        { !consent &&
          <div>
            <span>{translate(getLanguage(), "This site uses cookies. To find out more visit")}</span>
            <a href="http://www.liknoss.com/cookie-policy">&nbsp;this link.</a>
            <button style={{ marginLeft: 8, padding: "8px 16px", background: "rgb(41,63,84)", color: "white", border: 0, cursor: "pointer"}}onClick={this.handleClick}>{translate(getLanguage(), "Accept")}</button>
          </div>
        }
      </div>
    );
  }
}

const AnalyticsTracker = () => (<Route component={Analytics} />);

class App extends Component {
  constructor(props) {
    super(props);
    this.parseQueryString = this.parseQueryString.bind(this);
  }


  parseQueryString(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
        query_string[pair[0]] = arr;
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    }
    return query_string;
  }

  refersh() {
    let tag = localStorage.getItem("dfpTag");
    let value = localStorage.getItem("dfpValue");

    if(tag != "agency"){
      DFPManager.setTargetingArguments( { 'agency' : 'N'} )
    }
    DFPManager.setTargetingArguments( { [tag] : value} )
    DFPManager.refresh();
  }

  componentWillMount() {
    
    const query = window.location.search.substring(1);
    const qs = this.parseQueryString(query);
  }

  componentDidMount() {
    DFPManager.load();
    this.interval = setInterval(() => this.refersh(), 32000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <BrowserRouter>
        <div>
          <AnalyticsTracker />
          <Switch>
            <Route 
                exact={true} 
                path="/" 
                render={props => (
                  (<Home
                    {...props}
                    data={this.props}
                    render={events => <HomeEvents events={events} />}
                    />)
                  )}
              />
            <Route
              exact={true}
              path="/mg/:language/ferries-schedules/:from/:to/:sdate/:edate"
              render={props => <ItinerariesPrintable {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/:from/:to/:sdate/:edate/itineraries"
              render={props => <Itineraries2 {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/:from/:to/:sdate/:edate/events"
              render={props => <Events {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/:from/:to/:sdate/:edate/ships"
              render={props => <Ships {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/:from/:to/:sdate/:edate/agencies"
              render={props => <Agencies {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/allevents"
              render={props => <Allevents {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/allagencies"
              render={props => <Allagencies {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/advertising-interest"
              render={props => <Advertise {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/terms"
              render={props => <Terms {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/contact"
              render={props => <Contact {...props} data={this.props} />}
            />
            <Route
              exact={true}
              path="/pages/:slug"
              render={props => <CustomPage {...props} data={this.props} />}
            />
            <Redirect to="/" />
          </Switch>
          <CookieConsent />
        </div>
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state) {
  return {
    settings: state.header,
    itineraries: state.itineraries,
    agencies: state.agencies,
    tripAgencies: state.tripAgencies,
    events: state.events,
    translation: state.translation
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js